/**
 * PDI Loyalty International API v1.5.20
 * Note: All dates/times returned via API call will be UTC / Accept-Encoding: gzip, deflate<br><br><a href='https://pditechnologies.com/engage-customers/loyalty-marketing-solutions/'>PDI Technologies website</a><br><a href='mailto:azpiral-info@pditechnologies.com?subject=AzpiralAPI'>Send an email to PDI Technologies</a><br><a href='../../Contents/FlowDiagrams/Index.htm'>Flow Diagrams</a><br><a href='../../v1/Helpers/ApiErrors/'>Error Codes</a>
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';
import OfferDetails from './OfferDetails';

/**
 * The OfferDetail model module.
 * @module model/OfferDetail
 * @version v1
 */
class OfferDetail {
    /**
     * Constructs a new <code>OfferDetail</code>.
     * @alias module:model/OfferDetail
     * @param offerId {Number} 
     * @param offerTypeId {Number} 
     * @param pointsCost {Number} 
     * @param offerDetails {module:model/OfferDetails} 
     */
    constructor(offerId, offerTypeId, pointsCost, offerDetails) { 
        
        OfferDetail.initialize(this, offerId, offerTypeId, pointsCost, offerDetails);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj, offerId, offerTypeId, pointsCost, offerDetails) { 
        obj['OfferId'] = offerId;
        obj['OfferTypeId'] = offerTypeId;
        obj['PointsCost'] = pointsCost;
        obj['OfferDetails'] = offerDetails;
    }

    /**
     * Constructs a <code>OfferDetail</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/OfferDetail} obj Optional instance to populate.
     * @return {module:model/OfferDetail} The populated <code>OfferDetail</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new OfferDetail();

            if (data.hasOwnProperty('OfferId')) {
                obj['OfferId'] = ApiClient.convertToType(data['OfferId'], 'Number');
            }
            if (data.hasOwnProperty('OfferTypeId')) {
                obj['OfferTypeId'] = ApiClient.convertToType(data['OfferTypeId'], 'Number');
            }
            if (data.hasOwnProperty('OfferText')) {
                obj['OfferText'] = ApiClient.convertToType(data['OfferText'], 'String');
            }
            if (data.hasOwnProperty('StartDate')) {
                obj['StartDate'] = ApiClient.convertToType(data['StartDate'], 'String');
            }
            if (data.hasOwnProperty('EndDate')) {
                obj['EndDate'] = ApiClient.convertToType(data['EndDate'], 'String');
            }
            if (data.hasOwnProperty('ImageLocation')) {
                obj['ImageLocation'] = ApiClient.convertToType(data['ImageLocation'], 'String');
            }
            if (data.hasOwnProperty('FindOutMore')) {
                obj['FindOutMore'] = ApiClient.convertToType(data['FindOutMore'], 'String');
            }
            if (data.hasOwnProperty('PointsCost')) {
                obj['PointsCost'] = ApiClient.convertToType(data['PointsCost'], 'Number');
            }
            if (data.hasOwnProperty('NboText')) {
                obj['NboText'] = ApiClient.convertToType(data['NboText'], 'String');
            }
            if (data.hasOwnProperty('OfferClass')) {
                obj['OfferClass'] = ApiClient.convertToType(data['OfferClass'], 'String');
            }
            if (data.hasOwnProperty('OfferDetails')) {
                obj['OfferDetails'] = OfferDetails.constructFromObject(data['OfferDetails']);
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>OfferDetail</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>OfferDetail</code>.
     */
    static validateJSON(data) {
        // check to make sure all required properties are present in the JSON string
        for (const property of OfferDetail.RequiredProperties) {
            if (!data[property]) {
                throw new Error("The required field `" + property + "` is not found in the JSON data: " + JSON.stringify(data));
            }
        }
        // ensure the json data is a string
        if (data['OfferText'] && !(typeof data['OfferText'] === 'string' || data['OfferText'] instanceof String)) {
            throw new Error("Expected the field `OfferText` to be a primitive type in the JSON string but got " + data['OfferText']);
        }
        // ensure the json data is a string
        if (data['StartDate'] && !(typeof data['StartDate'] === 'string' || data['StartDate'] instanceof String)) {
            throw new Error("Expected the field `StartDate` to be a primitive type in the JSON string but got " + data['StartDate']);
        }
        // ensure the json data is a string
        if (data['EndDate'] && !(typeof data['EndDate'] === 'string' || data['EndDate'] instanceof String)) {
            throw new Error("Expected the field `EndDate` to be a primitive type in the JSON string but got " + data['EndDate']);
        }
        // ensure the json data is a string
        if (data['ImageLocation'] && !(typeof data['ImageLocation'] === 'string' || data['ImageLocation'] instanceof String)) {
            throw new Error("Expected the field `ImageLocation` to be a primitive type in the JSON string but got " + data['ImageLocation']);
        }
        // ensure the json data is a string
        if (data['FindOutMore'] && !(typeof data['FindOutMore'] === 'string' || data['FindOutMore'] instanceof String)) {
            throw new Error("Expected the field `FindOutMore` to be a primitive type in the JSON string but got " + data['FindOutMore']);
        }
        // ensure the json data is a string
        if (data['NboText'] && !(typeof data['NboText'] === 'string' || data['NboText'] instanceof String)) {
            throw new Error("Expected the field `NboText` to be a primitive type in the JSON string but got " + data['NboText']);
        }
        // ensure the json data is a string
        if (data['OfferClass'] && !(typeof data['OfferClass'] === 'string' || data['OfferClass'] instanceof String)) {
            throw new Error("Expected the field `OfferClass` to be a primitive type in the JSON string but got " + data['OfferClass']);
        }
        // validate the optional field `OfferDetails`
        if (data['OfferDetails']) { // data not null
          OfferDetails.validateJSON(data['OfferDetails']);
        }

        return true;
    }


}

OfferDetail.RequiredProperties = ["OfferId", "OfferTypeId", "PointsCost", "OfferDetails"];

/**
 * @member {Number} OfferId
 */
OfferDetail.prototype['OfferId'] = undefined;

/**
 * @member {Number} OfferTypeId
 */
OfferDetail.prototype['OfferTypeId'] = undefined;

/**
 * MaxLength:250
 * @member {String} OfferText
 */
OfferDetail.prototype['OfferText'] = undefined;

/**
 * Format [yyyy-MM-dd HH:mm:ss] UTC
 * @member {String} StartDate
 */
OfferDetail.prototype['StartDate'] = undefined;

/**
 * Format [yyyy-MM-dd HH:mm:ss] UTC
 * @member {String} EndDate
 */
OfferDetail.prototype['EndDate'] = undefined;

/**
 * MaxLength:500
 * @member {String} ImageLocation
 */
OfferDetail.prototype['ImageLocation'] = undefined;

/**
 * MaxLength:500
 * @member {String} FindOutMore
 */
OfferDetail.prototype['FindOutMore'] = undefined;

/**
 * @member {Number} PointsCost
 */
OfferDetail.prototype['PointsCost'] = undefined;

/**
 * MaxLength:50
 * @member {String} NboText
 */
OfferDetail.prototype['NboText'] = undefined;

/**
 * MaxLength:10
 * @member {String} OfferClass
 */
OfferDetail.prototype['OfferClass'] = undefined;

/**
 * @member {module:model/OfferDetails} OfferDetails
 */
OfferDetail.prototype['OfferDetails'] = undefined;






export default OfferDetail;

